module.exports = __webpack_public_path__ + "9788f41e/img/menu-icon.5f8facae.svg";